import React from 'react';
import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const wasteProductRoutes = ({
    List, Edit
}: {
    List: React.ComponentType;
    Edit: React.ComponentType;
}) => (
    <Routes>
        <Route path="" element={<List />} />
        <Route path={ROUTES.MASTER_DATA.WASTE_PRODUCT.CREATE} element={<Edit />} />
        <Route path={ROUTES.MASTER_DATA.WASTE_PRODUCT.EDIT} element={<Edit />} />
    </Routes>
);

